/* @flow */

import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: calc(100vh - 60px);
  background: url(${require('./testImg/banner-bg.jpg')}) center center;
  background-size: cover;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  display: table;
  height: 100%;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMLight};
  vertical-align: middle;
`;
const Row = styled.div`
  display: table-cell;
  vertical-align: middle;
`;
const Title = styled.div`
  color: #fff;
  font-size: 80px;
  font-weight: 300;
  margin-bottom: 40px;
  font-family: ${({ theme }) => theme.fontIBMExtraLight};
`;
const Description = styled.div`
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontIBMRegular};
`;

type Props = {
  i18n: Object,
};

export default
@withI18n
class Banner extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
  };

  render() {
    const { i18n } = this.props;
    return (
      <WrapperBox direction="column">
        <Content>
          <Row>
            <Title>{getLabel('exchange-banner-binancePressCenter', i18n)}</Title>
            <Description>{getLabel('exchange-banner-follow', i18n)}</Description>
          </Row>
        </Content>
      </WrapperBox>
    );
  }
}
